import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EmployeeInviteFormFactory } from './employee-invite-form.factory';
import { AlertMessageStore } from '../../../../../../modules/src/lib/core/stores/alert-message.store';
import { LoggingService } from '../../../../../../modules/src/lib/core/services/logging.service';
import { AlertMessageModel } from '../../../../../../modules/src/lib/core/models/alert-message.model';
import { SeverityTypeEnum } from '../../../../../../modules/src/lib/core/enums/severity-type.enum';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { AlertContextEnum } from '../../../../../../modules/src/lib/core/enums/alert-context.enum';
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import { InviteCreationOptions } from '../../../../../../../../common/src/options/invite-creation.options';
import { EmployeeRoleEnum } from '../../../../../../../../common/src/enums/employee-role.enum';
import { EmployeeApiController } from '../../../api-controllers/employee.api-controller';
import { Subscription } from 'rxjs';
import { AlertMessageFactory } from '../../../../../../modules/src/lib/core/factories/alert-message.factory';

@Component({
  selector: 'app-employee-invite',
  templateUrl: './employee-invite.component.html',
  styleUrls: ['./employee-invite.component.scss'],
  standalone: false,
})
export class EmployeeInviteComponent implements OnInit {

  public form: AdvancedForm<InviteCreationOptions> = this.formFactory.create();

  public buttonSubscription: Subscription;

  @Output()
  inviteSent = new EventEmitter<string>();

  constructor(public readonly formFactory: EmployeeInviteFormFactory,
              private readonly alertMessageStore: AlertMessageStore,
              private readonly loggingService: LoggingService,
              private readonly employeeApiController: EmployeeApiController) {
  }

  get email(): AdvancedFormControl<string, string, string> {
    return this.form.formElements.email as AdvancedFormControl<string, string, string>;
  }

  get role(): AdvancedFormControl<EmployeeRoleEnum, EmployeeRoleEnum, EmployeeRoleEnum> {
    return this.form.formElements.role as AdvancedFormControl<EmployeeRoleEnum, EmployeeRoleEnum, EmployeeRoleEnum>;
  }

  ngOnInit(): void {
    this.subscribeToButton();
  }

  subscribeToButton() {
    this.buttonSubscription = this.form.buttonClick$.subscribe(async () => {
      this.loggingService.debug('yeah, valid form');
      this.form.lifecycleStatus = FormLifecycleStatusEnum.Sending;

      this.loggingService.debug(JSON.stringify(this.form.value));
      const options: InviteCreationOptions = this.form.value;
      try {
        const response = await this.employeeApiController.create(options);
        this.alertMessageStore.save(new AlertMessageModel(SeverityTypeEnum.Success, AlertContextEnum.Global, {
          fr: 'L\'invitation a bel et bien été envoyée.',
          en: 'The invitation has been properly sent.',
        }));

        this.loggingService.debug('[invite-create] - Response returned', response);

        // We create a new form.
        this.form = this.formFactory.create();
        this.buttonSubscription.unsubscribe();
        this.subscribeToButton();
        this.inviteSent.emit('complete');
      } catch (e) {
        this.loggingService.error('[invite-create] - Error creating invite', e);
        if (e.status === 400 && e.error?.message === 'Validation error') {
          this.alertMessageStore.saveAll(AlertMessageFactory.createValidationAlertMessage(e, SeverityTypeEnum.Error));
          this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
        }
      }
    });
  }


}
